var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimerDefaultDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 4V12M24.5 12C15.6634 12 8.5 19.1634 8.5 28C8.5 36.8366 15.6634 44 24.5 44C33.3366 44 40.5 36.8366 40.5 28C40.5 19.1634 33.3366 12 24.5 12ZM20.5 4H28.5M39.2324 10.6436L41.3537 12.7649M29.776 22.2002L24.1191 27.857M29.8033 22.1968L24.1465 27.8536",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerDefaultDark);
export default __webpack_public_path__ + "static/media/timer-default-dark.25df4f5780d68f6b1f72521702ceeb2a.svg";
export { ForwardRef as ReactComponent };